import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 17a5 5 0 0 0 0 -10v10","key":"svg-1"}]]

const IconContrast = createReactComponent('outline', 'contrast', 'Contrast', __iconNode);

export default IconContrast;